import React from "react";
import "./App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { WhoWeAre } from "./components/WhoWeAre";
import { ProductsServices } from "./components/ProductsServices";
import { TechnologyPartners } from "./components/TechnologyPartners";
import { OurClients } from "./components/OurClients";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { ContactUs } from "./components/ContactUs";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhoWeAre />
      <ProductsServices />
      <TechnologyPartners />
      <OurClients />
      <WhyChooseUs />
      <ContactUs />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
